import * as React from 'react'

import ExchangeRateConfigurationContainer from './exchangeRateConfigurationContainer'
import { RouteComponentProps } from '@/app/navigation/withRouter'

export const ExchangeRatePageContent = ({
  match,
}: RouteComponentProps<{ companyId: string }>) => {
  return (
    <div data-testid="exchange-rate-page" className='tw-h-full tw-overflow-y-auto'>
      <ExchangeRateConfigurationContainer companyId={match.params.companyId} />
    </div>
  )
}
